import { useSelector } from 'react-redux';
import { selectUserProjectId } from 'core/userContext/selectors';

/**
 * Utility function that prefixes a string with the user's project.
 */
export const prefixWithUserProject = (str: string): string => {
  const userProjectId = useSelector(selectUserProjectId);
  return `proj-${userProjectId}-${str}`;
};
